import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';

/**
 * Contract for retrieving the current user's account information.
 */
@ApiContract({ endpoint: Api.getAccount, httpMethod: HttpMethods.get })
export class ApiGetAccount {
  constructor() {}
}
